import { useState } from "react";
import { createPortal } from "react-dom";
import { useScreenSize } from "@/hooks/useScreenSize";
import { Drawer, DrawerContent } from "@/components/ui/Drawer";
import { X } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
import { SettingsContent } from "./SettingsContent";

interface SystemSettingsDialogProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function SystemSettingsDialog({
  open: controlledOpen,
  onOpenChange,
}: SystemSettingsDialogProps = {}) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isMobile = useScreenSize(768);

  const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
  const setOpen = onOpenChange || setInternalOpen;

  const DesktopContent = () => {
    return createPortal(
      <div
        className={cn(
          "fixed inset-y-0 right-0 left-0 md:left-80 z-[100] bg-background shadow-2xl transition-transform duration-300 ease-in-out transform",
          open ? "translate-x-0" : "translate-x-full"
        )}
      >
        <div className="h-full flex flex-col">
          <div className="flex items-center justify-between px-6 py-4 border-b bg-white">
            <h2 className="text-lg">系统设置</h2>
            <Button variant="ghost" size="icon" onClick={() => setOpen(false)}>
              <X className="w-5 h-5" />
            </Button>
          </div>

          <div className="flex-1 overflow-hidden">
            <SettingsContent />
          </div>
        </div>
      </div>,
      document.body
    );
  };

  if (isMobile) {
    return (
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerContent className="bg-[#fafafa] h-[95vh]">
          <SettingsContent onClose={() => setOpen(false)} />
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-black/20 z-40 md:hidden"
          onClick={() => setOpen(false)}
        />
      )}
      <DesktopContent />
    </>
  );
}
